import { HttpInterceptorFn } from '@angular/common/http';
import { CalAngularService } from '@cvx/cal-angular';
import { environment } from 'src/environments/environment';
import { inject } from '@angular/core';
import { mergeMap } from 'rxjs';


export const tokenInterceptor: HttpInterceptorFn = (req, next) => {

  const calService = inject(CalAngularService);

  const scopes = environment.acreageApiScope;

  return calService.getAADToken([scopes]).pipe(
    mergeMap(token => {

      // Do not set the auth header if CAL fails to return a token
      if (!token) {
        return next(req);
      }

      const modifiedReq = req.clone({
        headers: req.headers.set('Authorization', `Bearer ${token}`),
      });

      return next(modifiedReq);
    })
  );

};
